export const codeSuccessPay = {
  baokim: 'c',
  internationalCard: "00",
  localCard: "00",
  momo: "0",
  qrgen: '0'
};
export const cancerPay = {
  internationalCard: "03",
  localCard: "18",
};
